export default __webpack_public_path__ + "static/media/LogoAcceso.96a2318c.png";